<template>
	<el-form-item id="image-list"  :prop="item.category">
		<div class="attachment-header upload-image upload-demo">
			<h2 v-on:click="$emit('show-modal',item)" class="image-upload-title attachment-title">{{item.name}}<span style="font-size:14px;font-weight:300;color:#909399;">&nbsp;&nbsp;(JPEG/JPG format)</span></h2>
		</div>

		<!-- UPLOADER -->
		<el-upload drag :limit="image_limit" :on-exceed="onExceed" accept="image/jpeg" :on-error="onError" :on-success="onSuccess"  :action="upload_api" :auto-upload="true" :file-list="file_list" :show-file-list="false" :before-upload="testingImg">
			<i class="el-icon-upload"></i>
			<div class="el-upload__text">Drop file here or <em>click to upload</em></div>
			<div class="el-upload__tip" slot="tip">jpg files only</div>
		</el-upload>

		<!-- CUSTOM ATTACHMENT VIEW -->
		<div style="margin:20px">
			<div class="image-item" v-for="(file, index) in photos" :key="index" style="display:flex;" >
				<div :style="{backgroundImage: `url(${encodeURI(file.url)})`, width:'100px', backgroundSize: 'cover'}">
				</div>
				<div class="image-details">
					<div class="">
						<b>Name: </b>&nbsp; {{file.name}}
					</div>
					<div style="display:flex;">
						<div style="height:30px;line-height:30px;"><b>Caption: &nbsp;</b></div>
						<el-input class="plain-input" placeholder="Enter caption here" maxlength="200" v-model="file.caption" style="flex-grow:1">

						</el-input>
					</div>

				</div>


				<el-button type="text" style="padding:12px" icon="el-icon-delete" @click="onRemove(file)">
				</el-button>



			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</el-form-item>
</template>

<script>
import attachment_mixin from '@/js/mixins/attachment-mixin.js';
import { mapMultiRowFields } from 'vuex-map-fields';
export default {
	mixins: [ attachment_mixin ],
	props: ['item'],
	data(){
		return {
			dialogImageUrl: '',
			dialogVisible: false,
			image_limit: 20,
			prop: this.item.category
		};
	},
	computed:{
		...mapMultiRowFields('application/attachments', ['photos'])
	},
	methods: {
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		onExceed(){
			this.$notify.error({
				title: 'Limit Reached',
				message: `You are limited to ${this.image_limit} photos`
			})
		},
		onSuccess(response, raw_file){
			const { application_hash } = this.$route.params;

			const file = {
				name: raw_file.name,
				caption:null,
				url: `${process.env.VUE_APP_API_PATH}/files/thumbnail.php?hash=${application_hash}&name=${raw_file.name}`
			};

			this.$store.dispatch('application/attachments/addFileToStore', { category: this.item.category, file } );
			this.$emit('validation-needed', this.prop); // Validate field on success
		},
	}
}
</script>

<style lang="scss">
.plain-input{
	> .el-input__inner{
		height:30px;
		line-height:30px;
		border:none !important;
		background-color: rgb(240,244,250);
		border-radius: 8px;
		/* margin-left: 7px; */
		padding-left: 10px;
	}

}
.image-details{
	flex-grow:1;
	padding:10px 0 10px 15px;
	b{
		color:rgba(0,0,0,.69) !important;
	}
	> div{
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		&:first-child{}
	}

}
#image-list{
	.el-input-group__prepend{
		padding:0 !important;
		height:100%;
	}
	.el-upload{width:100%;margin-top:15px;}
	.el-upload__top, .el-upload-list{
		display:none;
	}
	.el-upload-dragger{
		border: 1px dotted lightgray !important;
		padding: 15px;
		.el-icon-upload{
			margin-top:10px;
		}
	}
	.image-item{
		background:white;
		box-shadow:0 .875px 3px rgba(0,0,0,.3);
		border-radius:12px;
		overflow:hidden;
		&:not(:first-child){
			margin-top:10px;
		}
	}
}

h2.image-upload-title {display:block !important;text-align:left !important;width:100% !important;}
</style>
